// Module
import React, { useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';

// CSS
import '_Asset/css/User/Include/header.css'

// Component
import i18next from "Lang/i18n"
import { menuList } from 'User/Component/MenuList';
import { setLoggedCust } from 'Modules/authority';

// API
import { CmLogoutApi, CmRePassApi } from '_Route/Api';


const Header = ({fixedState, setFixedState}) => {
  
  // Use Hooks
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Location Check
  const path = location.pathname
  const pathChk = path.split('/')[1];

  const sessionID = localStorage.getItem('custSessionID')
  const isLoginCust = useSelector(state => state.loggedCust)
  const userName = useSelector(state => state.authorityCust.name); // 로그인된 회원 이름
  const changePassStatus = useSelector(state => state.authorityCust.changePass); // 비밀번호 변경 여부 [0, 1]
  
  const [popUpState, setPopUpState] = useState(false);

  const [info, setInfo] = useState({ // 비밀번호 변경 정보
    cust_email: '',
    cust_pass: '',
    cust_change_pass: '',
    cust_change_pass_check: '',
  })
  const { cust_email, cust_pass, cust_change_pass, cust_change_pass_check } = info

  // Language List / Active
  const langList = [
    {code: "ko-KR", flagUrl: 'South_Korea.svg'},
    {code: "en-US", flagUrl: 'United_States.svg'}
  ]
  const [langActive, setLangActive] = useState(false);
  const [langIdx, setLangIdx] = useState(0);
  
  const langBtn = () => {
    setLangActive(!langActive)
  }


  /*========================================================================
  * onHandler Func
  ========================================================================*/
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }

  
  /*========================================================================
  * Header Fixed Event
  ========================================================================*/
  const subHeaderRef = useRef(null);
  
  window.onscroll = () => {
    if(subHeaderRef.current?.clientHeight - 35 < window.scrollY) {
      setFixedState(true)
    } else {
      setFixedState(false)
    }
  };


  /*========================================================================
  * 고객 비밀번호 변경
  ========================================================================*/
  // const getCustSg = () => {
  //   axios({
  //     method: 'GET',
  //     url: CmSgApi,
  //     headers: {
  //       "Content-Type": "application/json",
  //       'Authorization': sessionID,
  //     },
  //     params: {}
  //   })
  //   .then(res => {
  //     console.log("Current Customer Data PUT Success!", res)
  //   })
  //   .catch(err => {
  //     console.error("Customer Password PUT Error...", err)
  //   })
  // }

  const passChange = () => {
    axios({
      method: 'PUT',
      url: CmRePassApi,
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      // console.log("Customer Password PUT Success!", res)

      navigate(location.pathname) // 고객 정보 갱신
      alert(`${userName}님의 비밀번호가 성공적으로 변경되었습니다.`)
      setPopUpState(false)
      Object.keys(info).map(key => info[key] = '')
      setInfo({...info})
    })
    .catch(err => {
      console.error("Customer Password PUT Error...", err)
      alert(err.response.data.message)
    })
  }


  /*========================================================================
  * 고객 로그아웃
  ========================================================================*/
  const Logout = () => {
    axios.defaults.withCredentials = true;
    axios({
      method: 'GET',
      url: CmLogoutApi,
    })
    .then(res => {
      // console.log(res, "Customer Logout Success!")

      dispatch(setLoggedCust(false))
      localStorage.removeItem('custSessionID')
      alert("로그아웃을 완료하였습니다.")
    })
    .catch(err => { 
      console.error(err, "Customer Logout Error...")
    })
  } 

  const Logged = () => {
    if (isLoginCust) {
      Logout()
    } else {
      navigate('/customer-login')
    }
  }

  
  return (
    <header className={`userHeader theme ${fixedState ? 'fixed' : ''}`}>
      <div className="container">
        {/* Lang, Profile 영역 */}
        {/* <div className="subHeader" ref={subHeaderRef}>
          <div className="innerSubHeader">
            <button className="lang" onClick={langBtn}>
              <p><img src={require(`_Asset/img/flag/${langList[langIdx].flagUrl}`)} alt="" /></p>
              <span>{t(`lang_${i18next.language}`)}</span>
              <i className={`icofont-rounded-${langActive ? "up" : "down"}`}></i>
              {
                langActive &&
                <ul>
                  {langList.map((key, i) => 
                    <li key={i} onClick={() => {i18next.changeLanguage(key.code); setLangIdx(i)}}>{t(`lang_${key.code}`)}</li>
                  )}
                </ul>
              }
            </button>

            <div className="profile">
              <p>
                <i className="icofont-user-alt-7"></i>
                {isLoginCust && `${userName ?? ''} 님 반갑습니다.`}
              </p>
              <button type="button" onClick={Logged}>{isLoginCust ? '로그아웃' : '로그인'}</button>

              {isLoginCust &&
                <React.Fragment>
                  <button type="button" onClick={() => setPopUpState(true)}>비밀번호 변경</button>
                  {changePassStatus === 0 &&
                    <div className="msgBox top black">
                      <h2><i className="icofont-warning-alt"></i>비밀번호 변경 필수</h2>
                      <p>
                        아직 임시 비밀번호가 변경되지 않았습니다.<br />
                        임시 비밀번호를 변경해주세요.
                      </p>
                    </div>
                  }
                </React.Fragment>
              }
            </div>
          </div>
        </div> */}
        
        {/* LOGO, Main Menu 영역 */}
        <div className="mainHeader"> 
          <div className="innerMainHeader">
            <div className="pageName">
              <a href="https://seyfert.kr" target="_blank" title="새창에서 열림">
                <img src={require('_Asset/img/seyfert_logo.svg').default} alt='' />
              </a>
              <Link to="/" className="developers">Developers</Link>
            </div>

            <div className={`menuList ${pathChk ? pathChk : 'main'}`}>
              <ul>
                {menuList.map((key, i) =>
                  <li key={i} className={pathChk === key.menu ? 'active' : ''} ><Link to={`/${key.menu}`} >{key.menu.charAt(0).toUpperCase() + key.menu.slice(1)}</Link></li>
                )}
                <div className="navUnderline"></div>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* 고객 비밀번호 변경 POPUP */}
      <div className={`modal ${popUpState ? 'show' : ''}`}>
        <div className="modalBox">
          <div className="modalHeader">
            <h2>비밀번호 변경</h2>
          </div>

          <div className="modalBody">
            <p className="modalBodyTit center">안전한 비밀번호로 내 정보를 보호하세요.</p>

            <fieldset>
              <legend>비밀번호 변경</legend>

              <div className="fieldGroup">
                <label>이메일 ID</label>
                
                <div className="field full">
                  <input type="email" className="input round_10 md" name="cust_email" onChange={(e) => onChange(e)} value={cust_email || ''} placeholder='이메일 ID를 입력해주세요.' />
                </div>
              </div>

              <div className="fieldGroup">
                <label>현재 비밀번호</label>
                
                <div className="field full">
                  <input type="password" className="input round_10 md" name="cust_pass" onChange={(e) => onChange(e)} value={cust_pass} placeholder='현재 비밀번호를 입력해주세요.' />
                </div>
              </div>

              <div className="fieldGroup">
                <label>새 비밀번호</label>
                
                <div className="field full col">
                  <input type="password" className="input round_10 md" name="cust_change_pass" onChange={(e) => onChange(e)} value={cust_change_pass} placeholder='새 비밀번호를 입력해주세요.' />
                  <input type="password" className="input round_10 md" name="cust_change_pass_check" onChange={(e) => onChange(e)} value={cust_change_pass_check} placeholder='새 비밀번호를 다시 한번 입력해주세요.' />
                </div>
              </div>
            </fieldset>
          </div>

          <div className="modalFoot">
            <button type="button" className="btn sm blue_edge round_10" onClick={() => setPopUpState(false)}>취소</button>
            <button type="button" className="btn sm sfrtBlue round_10" onClick={passChange}>변경 완료</button>
          </div>
        </div>
      </div>
    </header>
  )
}
export default Header;
